module.exports = __webpack_public_path__ + "static/img/shinhanbank-edusol.e68a58b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/shinhanbank-edusol.jpg
// module id = GfUC
// module chunks = 0